module.exports = __webpack_public_path__ + "media/images/noticeDesktop-b8d4647ad43efc8820d4da10ecc6e0db.svg";